module.exports = __webpack_public_path__ + "loading-bbdac9cda255c54bfd809110aff87898.gif";


//////////////////
// WEBPACK FOOTER
// ./~/lightgallery/dist/img/loading.gif
// module id = 917
// module chunks = 124